const home = 0,
  tableView = 100;

export { home, tableView };
